/** @jsxImportSource @emotion/react */
import css from '@emotion/css/macro'

import { SkeletonRow } from 'src/components/ts-components/SkeletonBlock'

const CHIP_COUNT = 3
const CHIP_HEIGHT = 32

/** Cold-load placeholder for the sport chips row. */
const SportChipsSkeleton = () => {
  'use memo'

  return (
    <div aria-hidden='true' css={rowStyles}>
      {Array.from({ length: CHIP_COUNT }, (_, i) => (
        <div key={i} css={chipStyles}>
          <SkeletonRow height={CHIP_HEIGHT} />
        </div>
      ))}
    </div>
  )
}

// ─── Styles ──────────────────────────────────────────────────────

const rowStyles = css`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`

const chipStyles = css`
  width: 96px;
`

export default SportChipsSkeleton
